
import { CtepBrandID, getBrandName } from "@/utils/ctep/ctep-brands";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import { BankConfig, ICtepDefaultBankForPaymentType } from "@/models/dossier-configs/bank-config";

export default Vue.extend({
	data(){
		return {
			setting: {
				PaymentType: CtepBrandID.BANCONTACT,
				BankTypeID: 0
			} as ICtepDefaultBankForPaymentType
		};
	},
	props: {
		value: {
			type: Object as ()=>ICtepDefaultBankForPaymentType,
			required: true
		},
		allSettings: {
			type: Object as ()=>BankConfig,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("ctep-bank-per-brand");
		},
		brandItems():ISelectItem<CtepBrandID>[]{
			let items = getEnumKeys(CtepBrandID).map(k=>{
				return getEnumValueFromKey(CtepBrandID, k);
			});

			items = items.filter(item=>{
				if (item == this.value.PaymentType) return true;
				let i = this.allSettings.CtepDefaultBankForPaymentTypes.findIndex(b=>b.PaymentType == item);
				return i == -1;
			});

			return items.map(i=>{
				return {
					text: getBrandName(i),
					value: i
				} as ISelectItem<CtepBrandID>;
			});
		},
		canChangeBrand():boolean{
			return (this.value.PaymentType as any) == "";
		},
		canSave():boolean {
			if (this.setting.PaymentType as any == "") return false;
			return this.setting.BankTypeID != 0;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			if (!this.canSave) return;
			this.value.PaymentType = this.setting.PaymentType;
			this.value.BankTypeID = this.setting.BankTypeID;
			this.$emit("confirm");
			this.close();
		}
	},
	mounted(){
		if (this.value.PaymentType as any == 0){
			this.setting.PaymentType = this.brandItems[0].value;
		}else{
			this.setting.PaymentType = this.value.PaymentType;
			this.setting.BankTypeID = this.value.BankTypeID;
		}
	},
	components: {
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
